import { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import { Box } from '@givebutter/primitives/box';
import { Loader } from '@givebutter/primitives/loader';
import { WorkflowDetailMetricCards } from 'assets/js/pages/engage/workflows/components/WorkflowDetailMetricCards';
import { WorkflowDetailsActionMetrics } from 'assets/js/pages/engage/workflows/components/WorkflowDetailsActionMetrics';
import { WorkflowDetailsActivityTable } from 'assets/js/pages/engage/workflows/components/WorkflowDetailsActivityTable';
import { WorkflowDetailsErrorBoundary } from 'assets/js/pages/engage/workflows/components/WorkflowDetailsErrorBoundary';
import { WorkflowDetailsHeader } from 'assets/js/pages/engage/workflows/components/WorkflowDetailsHeader';
import { WorkflowDetailsTriggerVolumeChart } from 'assets/js/pages/engage/workflows/components/WorkflowDetailsTriggerVolumeChart';
import * as Breadcrumbs from 'components/breadcrumbs';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentWorkflow } from 'customHooks/useCurrentWorkflow';

const WorkflowDetails = () => {
    const location = useLocation();
    const { accountId } = useCurrentAccount();
    const { data: workflow } = useCurrentWorkflow();
    const workflowsIndexPath = `/accounts/${accountId}/workflows`;

    return (
        <div className="flex flex-col gap-4 pb-12">
            <Breadcrumbs.Root>
                <Breadcrumbs.Crumb to={workflowsIndexPath}>Workflows</Breadcrumbs.Crumb>
                <Breadcrumbs.Crumb to={location.pathname} className="flex items-center gap-2">
                    <span>{workflow.icon}</span>
                    <span>{workflow.name}</span>
                </Breadcrumbs.Crumb>
            </Breadcrumbs.Root>

            <ReactFlowProvider>
                <WorkflowDetailsHeader />
            </ReactFlowProvider>

            <div className="relative flex flex-col gap-4">
                <WorkflowDetailsErrorBoundary>
                    <Suspense
                        fallback={
                            <Box className="p-8">
                                <Loader variant="static" className="h-40" />
                            </Box>
                        }
                    >
                        <WorkflowDetailMetricCards />
                        <WorkflowDetailsTriggerVolumeChart />
                        <WorkflowDetailsActionMetrics />
                        <WorkflowDetailsActivityTable />
                    </Suspense>
                </WorkflowDetailsErrorBoundary>
            </div>
        </div>
    );
};

export { WorkflowDetails };
